import { mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledCard = styled.div.withConfig({ displayName: "StyledCard", componentId: "sc-4578li" }) `
  border-radius: ${(props) => props.theme.radii.primary};
  background-color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x3};

  ${(props) => mq({
    boxShadow: props.theme.shadows.tertiary,
    width: ['auto', null, '261px'],
})}
`;
